import { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import { NotificationsList } from '../types/notifications'
import http from './http'

export function getNotifications(
): AxiosPromise<AppApiResponseData<NotificationsList>> {
	return http({
		method: 'GET',
		url: `/s/notifications/true`,
	})
}
